export default "__VITE_ASSET__DMiM8nrD__"